import { Button } from "../../../../core/components/atoms/Button";
import { Icon } from "../../../../core/components/atoms/Icon";
import { useNewSubjectStore } from "../../stores/newSubjectStore";
import { usePrintComponentStore } from "../../../../core/components/organism/PrintComponent/store/usePrintComponentStore";
import { usePrintComponentRequestStore } from "../../../../core/components/organism/PrintComponent/store/usePrintComponentRequest";
import { useDisciplinesAuxStore } from "../../stores/auxStore";
import { useExerciseStore } from "../../stores/exercisesStore";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MultipleSelect from "../../../../core/components/atoms/MultipleSelect";
import FilterTagsList from "../FilterTagsList";
import { useAccess } from "../../../../core/accessControl/useAccess";
import { openFreemiumUpsell } from "../../../../core/stores/freemiumUpsellStore";
import './style.css';

interface ISubjectSelectSection {
  type: string;
  onFilterChange?: () => void;
}

const SubjectSelectSection: React.FC<ISubjectSelectSection> = ({ type, onFilterChange }) => {
  const location = useLocation();

  const { setSelectedSubjects, selectedSubjects, selectOptions } = useNewSubjectStore()

  const { setHasApiCall } = usePrintComponentStore();
  const { setOpenModal } = useDisciplinesAuxStore();
  const { isFreemium } = useAccess();

  const {
    difficulty,
    favorite,
    unanswered,
    rightAnswer,
    wrongAnswer,
    questionOptions,
    isEnem,
    selectedYear,
    institutionType
  } = useExerciseStore();

  const {
    setDifficulty: setPrintDifficulty,
    setFavorites: setPrintFavorites,
    setUnanswered: setPrintUnanswered,
    setRightAnswer: setPrintRightAnswer,
    setWrongAnswer: setPrintWrongAnswer,
    setQuestionOptions: setPrintQuestionOptions,
    setExerciseTypes: setPrintExerciseTypes,
    setSelectedYear: setPrintSelectedYear,
    setInstitutionType: setPrintInstitutionType
  } = usePrintComponentRequestStore();

  const syncFiltersAndOpenPrint = () => {
    if (isFreemium) {
      openFreemiumUpsell();
      return;
    }

    // Sincronizar filtros do exerciseStore para o printComponentRequestStore
    setPrintDifficulty(difficulty);
    setPrintFavorites(favorite);
    setPrintUnanswered(unanswered);
    setPrintRightAnswer(rightAnswer);
    setPrintWrongAnswer(wrongAnswer);
    setPrintQuestionOptions(questionOptions);
    setPrintSelectedYear(selectedYear);
    setPrintInstitutionType(institutionType);

    // Converter isEnem para exerciseTypes (enem -> enem, vestibulares -> vest)
    const exerciseTypes = isEnem.map(type => type === 'vestibulares' ? 'vest' : type);
    setPrintExerciseTypes(exerciseTypes);

    setHasApiCall(true);
    setOpenModal('exercise-print');
  };

  const SelectButtons = () => {
    if(type !== 'exercicio') {
      return (
        <Button variant='text' className='p-0' onClick={() => setOpenModal('normal-filter')}>
          <Icon
            Icon='filter_list'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='xs:text-sm md:text-md '>
            Filtrar { type === 'videoaula' ? 'videoaulas' : type === 'podcast' ? 'podcasts' : 'materiais' }
          </span>
        </Button>
      )
    }

    return (
      <div className='flex flex-row items-center gap-md w-fit'>
        <Button
          variant='text'
          onClick={syncFiltersAndOpenPrint}
          className='p-0'
        >
          <Icon
            Icon='print'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='text-sm xs:block md:hidden'>Imprimir</span>
          <span className='text-md xs:hidden md:block'>
            Imprimir lista de exercícios
          </span>
        </Button>
        <Button
          variant='text'
          onClick={() => {
            setOpenModal('exercise-filter');
          }}
          className='p-0'
        >
          <Icon
            Icon='filter_list'
            type='material'
            className='xs:text-sm md:text-md'
          />
          <span className='text-sm xs:block md:hidden'>Filtrar</span>
          <span className='text-md xs:hidden md:block'>
            Filtrar exercícios
          </span>
        </Button>
      </div>
    )
  }

  const handleSubjectsChange = (value: string[]) => {
    setSelectedSubjects(value);
  }

  useEffect(() => {
    // Recuperar subjects salvos do localStorage ao carregar
    // const savedSubjects = localStorage.getItem('selectedSubjects');
    // if (savedSubjects) {
    //   setSelectedSubjects(JSON.parse(savedSubjects));
    // }

    if (location.search) {
      // const queryParams = new URLSearchParams(location.search);
      // const subject = queryParams.get('subject');

      // if (subject) {
      //   setSelectedSubjects([subject]);
      //   localStorage.setItem('selectedSubjects', JSON.stringify([subject]));
      // }
    }
  }, [location, selectOptions]);

  // Salvar subjects no localStorage quando mudarem
  // useEffect(() => {
  //   localStorage.setItem('selectedSubjects', JSON.stringify(selectedSubjects));
  // }, [selectedSubjects]);

  return (
    <div className='flex flex-col gap-lg'>
      <div className="flex flex-row gap-lg items-center">
        <MultipleSelect
          label='Selecione os assuntos'
          options={selectOptions}
          selected={selectedSubjects}
          onChange={(value) => handleSubjectsChange(value)}
          className='flex-1'
        />
        {SelectButtons()}
      </div>
      <FilterTagsList origin="main" onFilterChange={onFilterChange} />
    </div>
  )
}

export default SubjectSelectSection;